import { fetchClient } from '../../Utils/helpers';
import {
  ADD_ONS,
  CHECKOUT_ADD_ON,
  CREATE_ADD_ONS,
  DELETE_ADD_ONS,
  DELIVERY_LIST,
  GET_CATEGORIES,
  GET_CONDITIONS, GET_REQ_STATUS, GET_SUBSCRIPTIONS, TOGGLE_SUBSCRIBED, VOLUME_UNIT,
} from '../actionTypes';

export function getCategories() {
  return {
    type: GET_CATEGORIES,
    payload: fetchClient({
      method: 'GET',
      url: '/item/categories',
    }),
  };
}

export function getConditions() {
  return {
    type: GET_CONDITIONS,
    payload: fetchClient({
      method: 'GET',
      url: '/item/conditions',
    }),
  };
}

export function getSubscriptions() {
  return {
    type: GET_SUBSCRIPTIONS,
    payload: fetchClient({
      method: 'GET',
      url: '/subscriptions',
    }),
  };
}

export function getRequestOutMethod() {
  return {
    type: DELIVERY_LIST,
    payload: fetchClient({
      method: 'GET',
      url: '/delivery',
    }),
  };
}

export function getAddOns(uid) {
  return {
    type: ADD_ONS,
    payload: fetchClient({
      method: 'GET',
      url: `/user-addons/${uid}?limit=10&page=1`,
    }),
  };
}

export function getAdminAddOns() {
  return {
    type: ADD_ONS,
    payload: fetchClient({
      method: 'GET',
      url: '/admin/addons',
    }),
  };
}

export function createAdminAddOns(data) {
  return {
    type: CREATE_ADD_ONS,
    payload: fetchClient({
      method: 'POST',
      url: '/admin/addons',
      data,
    }),
  };
}

export function deleteAdminAddOns(id) {
  return {
    type: DELETE_ADD_ONS,
    payload: fetchClient({
      method: 'DELETE',
      url: `/admin/addons/${id}`,
    }),
  };
}

export function checkoutAddOn(uid, data) {
  return {
    type: CHECKOUT_ADD_ON,
    payload: fetchClient({
      method: 'POST',
      url: `/user-addons/${uid}/checkout`,
      data,
    }).then((res) => {
      window.location.href = res.data.data?.url;
      return res.data;
    }),
  };
}

export function deleteAddOn(uid, data) {
  return {
    type: DELETE_ADD_ONS,
    payload: fetchClient({
      method: 'POST',
      url: `/user-addons/${uid}/cancel`,
      data,
    }),
  };
}

export function getRequestStatus() {
  return {
    type: GET_REQ_STATUS,
    payload: fetchClient({
      method: 'GET',
      url: '/admin/request-status',
    }),
  };
}

export function getVolumeUnit() {
  return {
    type: VOLUME_UNIT,
    payload: fetchClient({
      method: 'GET',
      url: '/public/options?type=volume',
    }),
  };
}

export function toggleSubscribed(id) {
  return {
    type: TOGGLE_SUBSCRIBED,
    payload: fetchClient({
      method: 'PUT',
      url: `/user/${id}/email`,
    }),
  };
}
